/** Small stat block used across Optimize sub-panels. */
export default function Stat({ label, value, color = "zinc", sub }) {
  const colorMap = {
    emerald: "text-emerald-600",
    red: "text-red-600",
    amber: "text-amber-600",
    blue: "text-blue-600",
    slate: "text-slate-900",
    zinc: "text-slate-900",
  };
  return (
    <div className="bg-white border border-slate-200 rounded p-2.5">
      <div className="text-[10px] uppercase tracking-wider text-slate-500 font-mono">{label}</div>
      <div className={`text-lg font-mono font-semibold ${colorMap[color]}`}>{value}</div>
      {sub && <div className="text-[10px] text-slate-500 font-mono">{sub}</div>}
    </div>
  );
}
